import React, { useState } from 'react';
import EditorColumn from './EditorColumn';
import CopyEmails from './CopyEmails';

const ChannelCard = ({logoBaseUrl, channel, channelAdminEditors}) => {
  const [showAllEditors, setShowAllEditors] = useState(false)
  const { id, title, logo, published_at, contract_date, yearly_contracted_articles, total_submitted_editor_check, published_count, state, has_digest } = channel
  const [screeningChannel, setScreeningChannel] = useState(channel.type == 'Channel::PeChannel' || channel.type == 'Channel::CommercialChannel')

  const renderLiveIcon = () => {
    if (state == "published") {
      return <img className="live-icon" src="https://public.cureus.com/admin/channels/live-icon.png"/>
    }
  }

  const renderDigestIcon = () => {
    if (has_digest == true) {
      return <p className="digest-paragraph"><img src='https://public.cureus.com/admin/channels/digest.png'/>Email Digest</p>
    }
  }

  const renderExpandButton = () => {
    if (isMoreThan3Editors()) {
      return <div className='expand-button'><i className="fas fa-chevron-down" onClick={() => {setShowAllEditors(!showAllEditors)}}/></div>
    }
  }

  const isMoreThan3Editors = () => {
    if (!channelAdminEditors) {
      return false
    } else if (checkMoreThan3Editors()) {
      return true
    } else {
      return false
    }
  }

  const checkMoreThan3Editors = () => {
    return filterByEditorType("ChannelAdmin").length > 3 || filterByEditorType("DeputyEditor").length > 3 || filterByEditorType("ChannelScreener").length > 3
  }

  const filterByEditorType = (type) => {
    if (channelAdminEditors) {
      return channelAdminEditors.filter( (admin) => {
        return admin.user_type == type
      })
    } else {
      return []
    }
  }

  const formatChannelName = () => {
  return channel.type.split('::')[1].replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

  const renderBadge = () => {
    const classname = formatChannelName()
    const badgeText = channel.type == 'Channel::CommercialChannel' ? 'Commercial' : 'PE'
    return (
      <div class="article-tier-badge-wrap right">
      <div class={`article-tier-badge  ${classname}`}><div class={`${classname} left-nubbins nubbins`}>{`${badgeText} Channel`}</div><div class={`${classname} right-nubbins nubbins`}></div></div>
      </div>
    )
  }

  return (
    <div className="card row">
      <div className="details section columns small-3">
        {renderLiveIcon()}
        <div className="row">
          <div className="columns small-12">
            <div className="row top-row">
              <div className="columns small-9">
                <h1><a target="_blank" href={`/admin/channels/${id}`}>{title}</a></h1>
              </div>
              <div className="columns small-3">
                <span data-tooltip="1" class="has-tip" title="Channel launch date">{published_at}</span>
              </div>
            </div>
            <div className="row">
              <div className="columns small-5">
                <img src={`${logoBaseUrl}/${id}/admin_sidebar_${logo}`}/>
              </div>
              <div className="columns small-7">
                {contract_date && <p>Contract date: {contract_date}</p>}
                {yearly_contracted_articles && <p>Annual article limit: {yearly_contracted_articles}</p>}
                <p>{total_submitted_editor_check} approved for editor check</p>
                <p>{published_count} published</p>
                {renderDigestIcon()}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section columns small-3">
        <EditorColumn showAllEditors={showAllEditors} type={screeningChannel ? 'ChannelScreener' : 'ChannelAdmin'} channelAdminEditors={channelAdminEditors} />
        {renderExpandButton()}
      </div>

      <div className="section columns small-3">
      {!screeningChannel && <EditorColumn showAllEditors={showAllEditors} type="DeputyEditor" channelAdminEditors={channelAdminEditors} /> }
      </div>

      <div className="section columns small-3">
        {screeningChannel && renderBadge()}
        <CopyEmails channelAdminEditors={channelAdminEditors}/>
      </div>
    </div>
  )
}

export default ChannelCard;